// ** Styled Components
import { StyledModalAuthWrapper } from "./styles/ModalAuthWrapper.styled";

// ** SVG Static Imports

import { StyledModalAuthComponent } from "./styles/ModalAuthComponent.styled";
import ModalVerifyPhoneContent from "containers/ModalVerifyPhone/ModalVerifyPhoneContent";

// #####################################################

const ModalVerifyPhoneRegistration = () => {
	// #####################################################
	return (
		<StyledModalAuthWrapper className="landingAlwaysLight">
			<StyledModalAuthComponent>
				<ModalVerifyPhoneContent />
			</StyledModalAuthComponent>
		</StyledModalAuthWrapper>
	);
};

// #####################################################

export default ModalVerifyPhoneRegistration;

// #####################################################
